export default __webpack_public_path__ + "static/media/Desktop-ModelX.83417303.jpeg";